export type UniversalProperty =
  | 'operationStatus'
  | 'operationMode'
  | 'fanMode'
  | 'swingMode'
  | 'setpoint'
  | 'dualSetpointLow'
  | 'dualSetpointHigh'
  | 'roomTemperature'
  | 'errorCode';

export const UNIVERSAL_PROPERTIES: Record<string, UniversalProperty> = {
  OPERATION_STATUS: 'operationStatus',
  OPERATION_MODE: 'operationMode',
  FAN_MODE: 'fanMode',
  SWING_MODE: 'swingMode',
  SETPOINT: 'setpoint',
  DUAL_SETPOINT_LOW: 'dualSetpointLow',
  DUAL_SETPOINT_HIGH: 'dualSetpointHigh',
  ROOM_TEMPERATURE: 'roomTemperature',
  ERROR_CODE: 'errorCode',
};

export const DEFAULT_TEMP_LIMITS_C: [number, number] = [16, 32];
export const DEFAULT_TEMP_LIMITS_F: [number, number] = [60, 90];
